import React from 'react';
import bannerImg from '../../assets/images/image 62.png';

const CollageBanner = ({ data }: { data?: any }) => {
  if (data?.gallery && data.gallery.length > 0) {
    return (
      <section className="max-w-7xl mx-auto px-4 md:px-10 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {data.gallery.map((item: any, index: number) => (
            <div key={index} className="w-full h-48 md:h-60 overflow-hidden shadow-sm hover:shadow-md transition-all">
              <img
                src={item.image_url}
                alt={item.caption || `Gallery Image ${index + 1}`}
                className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
              />
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-7xl mx-auto overflow-hidden">
      <img
        src={bannerImg}
        alt="Nisa Recruitment Collage"
        className="w-full h-auto object-cover"
      />
    </section>
  );
};

export default CollageBanner;
